import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "../global/styles/theme";
import { setToLS, getFromLS } from "../utils/storage";
interface ITheme {
  theme: "light" | "dark";
}
interface ThemeContextData {
  theme: ITheme;
  toggleTheme: () => void;
}
interface ThemeProviderProps {
  children: ReactNode;
}
export const ThemeContext = createContext({} as ThemeContextData);
function CustomThemeProvider({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState<ITheme>({ theme: "light" });
  function toggleTheme() {
    setTheme(theme.theme === "light" ? { theme: "dark" } : { theme: "light" });
    setToLS("@Theme", theme.theme === "light" ? { theme: "dark" } : { theme: "light" });

  }
  async function loadUserThemeStorage() {
    const storage = getFromLS("@Theme");
    if (storage) {
      setTheme(storage);
    }
  }
 
  useEffect(() => {
    loadUserThemeStorage();
  }, []);
  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme,
      }}
    >
      <ThemeProvider theme={theme.theme === "light" ? lightTheme : darkTheme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
function useTheme() {
  const context = useContext(ThemeContext);
  return context;
}

export { CustomThemeProvider as ThemeProvider, useTheme };
